import React from "react";

const AssessmentSlide = ({ questions, answers, onAnswer }) => {
  return (
    <div className="slide">
      {questions.map((q) => (
        <div key={q.id} className="question-card">
          <h3>{q.question_text}</h3>

          {q.options.map((opt, index) => {
            const value = typeof opt === "object" ? opt.value : opt;
            const label = typeof opt === "object" ? opt.label : opt;

            return (
              <label key={index} className="option">
                <input
                  type="radio"
                  name={`q_${q.id}`}
                  value={value}
                  checked={answers[q.id] === value}
                  onChange={() => onAnswer(q.id, value)}
                />
                <span>{label}</span>
              </label>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default AssessmentSlide;